/**
 * 波A · 长图模板库(§3.8 重定位)。
 *
 * `/ai-haibao/templates` 深链保留(可分享/收藏),但整页换壳:
 * 去 hero + 搜索 + 右下浮窗(那是 IMAGE 模板库的壳),换成与舱内页同一套卡墙语言 +
 * 面包屑「创意设计中心 / 长图模板」。筛选换成 用途 + 热门/最新(见 LongImageTemplateWall
 * 头注,ratio/tier/provider 已删)。点卡 → 带骨架整包进搭建器(B3,不再 ?templateId= 进创建页)。
 */
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import { templateHandoffState } from "../model/home/templateApply";
import { LongImageTemplateWall } from "./components/home/LongImageTemplateWall";

export default function PosterHomePage() {
  const navigate = useNavigate();

  return (
    <div className="w-full space-y-5 pb-10">
      <div className="flex flex-wrap items-center gap-3">
        <Link
          to="/ai-haibao"
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          创意设计中心
        </Link>
        <h1 className="text-lg font-bold">长图模板</h1>
        <p className="text-xs text-muted-foreground">
          选一套现成版式 → 骨架直接铺进搭建器,换成你的产品就能出
        </p>
      </div>

      <LongImageTemplateWall
        onPick={(t) => navigate("/ai-haibao/detail-long", { state: templateHandoffState(t) })}
      />
    </div>
  );
}
